module.exports = __webpack_public_path__ + "static/img/101841.6485bca5.png";